import FormCheckboxField from 'components/IAP/formFields/FormCheckboxField';
import { Row } from 'react-bootstrap';
import FormRadioField from 'components/IAP/formFields/FormRadioField';
import FormTextAreaField from 'components/IAP/formFields/FormTextAreaField';
import FormTextField from 'components/IAP/formFields/FormTextField';
import classNames from 'classnames';

type SectionReqContentProps = {
  memberPositions: { positionId: string; positionName: string }[];
};
export const SectionReqContent = ({
  memberPositions,
}: SectionReqContentProps) => {
  const isResl = memberPositions?.some(
    (pos) => pos.positionName === 'Resource Unit Leader'
  );
  const isLogsChief = memberPositions?.some(
    (pos) => pos.positionName === 'Logistics Section Chief'
  );
  const isFinanceChief = memberPositions?.some(
    (pos) => pos.positionName === 'Finance Section Chief'
  );

  return (
    <>
      <div
        className={classNames('border rounded p-2 mb-2', {
          'resource-disabled-section': !isResl,
        })}
      >
        <div>Plans/RESL</div>
        <Row>
          <div className="col-3">
            <FormCheckboxField
              title="Tactical"
              fieldName="resl_tac"
              disabled={!isResl}
            />
          </div>
          <div className="col-3">
            <FormCheckboxField
              title="Personnel"
              fieldName="resl_personnel"
              disabled={!isResl}
            />
          </div>
          <div className="col-3">
            <FormCheckboxField
              title="Available"
              fieldName="resl_available"
              disabled={!isResl}
            />
          </div>
        </Row>
      </div>
      <div
        className={classNames('border rounded p-2 mb-2', {
          'resource-disabled-section': !isLogsChief,
        })}
      >
        <div>Logistics</div>
        <Row>
          <div className="col-6">
            <FormTextField
              title="Requisition/Purchase Order Number"
              fieldName="logistics_order_number"
              disabled={!isLogsChief}
            />
          </div>

          <div className="col-2">
            <FormTextField
              title="Supplier Name"
              fieldName="supplier_name"
              disabled={!isLogsChief}
            />
          </div>

          <div className="col-2">
            <FormTextField
              title="Supplier Phone"
              fieldName="supplier_phone"
              disabled={!isLogsChief}
            />
          </div>
          <div className="col-2">
            <FormTextField
              title="Supplier Email"
              fieldName="supplier_email"
              disabled={!isLogsChief}
            />
          </div>
        </Row>
        <Row>
          <FormTextAreaField
            title="Notes"
            fieldName="logistics_notes"
            disabled={!isLogsChief}
          />
        </Row>
        <Row>
          <FormRadioField
            title="Order Placed By"
            fieldName="logistics_order_placed_by"
            options={['SPUL', 'PROC', 'Other']}
            disabled={!isLogsChief}
            className="d-flex justify-content-between pe-2"
          />
        </Row>
      </div>
      <div
        className={classNames('border rounded p-2 mb-2', {
          'resource-disabled-section': !isFinanceChief,
        })}
      >
        <div>Finance</div>
        <Row>
          <FormTextAreaField
            title="Reply/Comments from Finance"
            fieldName="finance_comments"
            disabled={!isFinanceChief}
          />
        </Row>
      </div>
    </>
  );
};
